<template>
  <div>
    <div class="center" v-if="detailsData && type === '0'">
      <h1 v-if="detailsData.title" class="title">
        <!--        阿尔茨海默病药物治疗的中英指南对英指南对治疗中英指南对 治疗的中英指南对-->
        {{ detailsData.title }}
      </h1>
      <ul class="content">
        <li v-if="detailsData.artSummary" class="msg">
          摘要：<span>
            {{ detailsData.artSummary }}
          </span>
        </li>
        <li v-if="detailsData.firstAuthor" class="msg">
          作者：<span>{{ detailsData.firstAuthor }}</span
          >&nbsp; <span>{{ detailsData.communicationAuthor }}</span
          >&nbsp;
          <span v-for="(item, i) in detailsData.articleAuthorList" :key="i"
            >{{ item.authorName }}&nbsp;</span
          >
        </li>
        <li v-if="detailsData.firstAuthorUnit" class="msg">
          作者单位：<span>{{ detailsData.firstAuthorUnit }}</span>
        </li>
        <!--        <li v-if="detailsData.artSummary" class="msg">-->
        <!--          摘要：<span>-->
        <!--            {{ detailsData.artSummary }}-->
        <!--          &lt;!&ndash;          张啸林 程颐韩 李文伟 袁刚 中山大学附属第一医院药学部&ndash;&gt;-->
        <!--          &lt;!&ndash;            中山大学附属医院老年不部&ndash;&gt;-->
        <!--          &lt;!&ndash;            阿尔茨海默病（AD）的临床症状多样且以认知功能损害为主,给患者和家庭带来了巨大的精神压力和沉重的经济负担。目前尚无根治AD的药物,临床上常采用胆碱酯酶抑制剂和美金刚改善AD症状,但其疗效不一且安全性和成本效果性存在差异。为给患者选择安全、有效、经济的用药方案,中国和英国分别在2018年更新的指南。中国发布《2018中国痴呆与认知障碍诊认知功能损害为主,给患者和家庭带来了巨大的精神压力和沉重的经济负担。目前尚无根治AD的药物,临床上常采用胆碱酯酶抑制剂和美金刚改善AD症状,但其疗效不一且安全性和成本效果性存在差异。为给患治指...&ndash;&gt;-->
        <!--          &lt;!&ndash;            阿尔茨海默病 治疗 药物疗法 指南 解读 中国全科医学 2021年第24卷第12期&ndash;&gt;-->
        <!--          &lt;!&ndash;            指南解读 国家自然科学基金资助项目（52007167） P136.95&ndash;&gt;-->
        <!--          &lt;!&ndash;            10.12114/j.issn.1007-9572.2021.00.121 5 1454-145 8&ndash;&gt;-->
        <!--          </span>-->
        <!--        </li>-->
        <li v-if="detailsData.keyword" class="msg">
          关键词：<span>{{ detailsData.keyword }}</span>
        </li>
        <li v-if="detailsData.periodical" class="msg">
          刊名：<span>{{ detailsData.periodical }}</span>
        </li>
        <li v-if="detailsData.period" class="msg">
          刊期：<span>{{ detailsData.period }}</span>
        </li>
        <li v-if="detailsData.articleColumn" class="msg">
          栏目：<span>{{ detailsData.articleColumn }}</span>
        </li>
        <li v-if="detailsData.fundName" class="msg">
          基金资助：<span>{{ detailsData.fundName }}</span>
        </li>
        <li v-if="detailsData.classifyNumber" class="msg">
          分类号：<span>{{ detailsData.classifyNumber }}</span>
        </li>
        <li v-if="detailsData.doi" class="msg">
          DOI：<span>{{ detailsData.doi }}</span>
        </li>
        <li v-if="detailsData.pageNumber" class="msg">
          页数：<span>{{ detailsData.pageNumber }}</span>
        </li>
        <li v-if="detailsData.sizeNumber" class="msg">
          页码：<span>{{ detailsData.sizeNumber }}</span>
        </li>
      </ul>
    </div>
    <div v-if="type === '0'" class="literature">
      <div class="kong"></div>
      <div class="title">
        <div class="left"></div>
        <div class="content">相似文献</div>
        <div class="right"></div>
      </div>
      <div class="list">
        <ul v-for="item in wenxian" :key="item.id">
          <li @click="detailsClick(item)">{{ item.title }}</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "center",
  props: ["detailsData", "type", "wenxian"],
  mounted() {},
  data() {
    return {
      act: 0,
    };
  },

  methods: {
    changeAct(i) {
      this.act = i;
    },

    detailsClick(e) {
      let routerUrl = this.$router.resolve({
        path: "details",
        query: {
          type: e.articleType,
          id: e.articleId,
        },
      });
      window.open(routerUrl.href, "_blank");
    },
  },
};
</script>

<style lang="scss" scoped>
.center {
  padding-top: 43px;
  width: 905px;
  //height: 657px;
  background: #ffffff;
  padding-bottom: 50px;
  box-shadow: 0px 7px 15px 1px rgba(22, 26, 100, 0.13);
  //padding-bottom: 50px;

  .title {
    width: 831px;
    height: 79px;
    font-size: 30px;
    //font-family: Microsoft YaHei;
    font-weight: bold;
    margin: 0 auto;
    color: #263d78;
    line-height: 48px;
  }

  .content {
    width: 830px;
    margin: 0px auto 0;

    .msg {
      margin-bottom: 5px;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #000000;
      line-height: 30px;
    }
  }
}

.literature {
  margin-top: 10px;
  width: 905px;
  //height: 356px;
  background: #ffffff;
  box-shadow: 0px 7px 15px 1px rgba(22, 26, 100, 0.13);
  padding-bottom: 50px;

  .kong {
    width: 100%;
    height: 40px;
    //background: pink;
  }

  .title {
    width: 854px;
    height: 40px;
    //background: yellow;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;

    .content {
      margin-left: 10px;
      margin-right: 10px;
    }

    .left,
    .right {
      width: 145px;
      height: 1px;
      background: #666666;
      //border: 1px solid #666666;
      opacity: 0.34;
    }
  }

  .list {
    width: 794px;
    margin: 40px auto 0;

    li {
      //background: pink;
      list-style: outside;
      margin-bottom: 20px;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #333333;
      height: 24px;
      line-height: 24px;
      cursor: pointer;
    }
  }
}

.Wcenter {
  width: 792px;
  //height: 513px;
  padding: 32px 34px 45px;
  background: #ffffff;
  box-shadow: 0px 7px 15px 1px rgba(22, 26, 100, 0.13);

  .content {
    width: 830px;
    margin: 33px auto 0;

    li {
      margin-top: 5px;

      .key {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        //background: yellow;
        color: #333333;
        margin-right: 12px;
      }

      .value {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
      }
    }
  }

  .top {
    display: flex;
    //justify-content: space-between;
    img {
      width: 100px;
      height: 130px;
      //background: pink;
      //float: left;
    }

    .title {
      //float: left;
      margin-left: 11px;
      font-size: 30px;
      font-weight: bold;
      color: #263d78;
    }

    .tips {
      margin-left: 11px;
      //width: 666px;
      //height: 16px;
      font-size: 14px;
      //font-family: Microsoft YaHei;
      font-weight: 400;
      color: #333333 !important;
      line-height: 30px;
    }
  }
}

.Wbottom {
  width: 792px;
  margin-top: 10px;
  padding: 34px;
  //height: 803px;
  background: #ffffff;
  box-shadow: 0px 7px 15px 1px rgba(22, 26, 100, 0.13);

  .nav {
    display: flex;

    div {
      margin-right: 50px;
      width: 80px;
      height: 20px;
      font-size: 20px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #333333;
      line-height: 24px;
    }

    .active {
      width: 80px;
      height: 20px;
      font-size: 20px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #0b35c5;
      line-height: 24px;
      position: relative;
    }

    .xian {
      position: absolute;
      width: 40px;
      left: 0;
      bottom: -10px;
      height: 3px;
      background: #0b35c5;
      border-radius: 1px;
    }
  }

  .daodu {
    margin-top: 40px;
    text-indent: 30px;
    min-height: 400px;
  }

  .mulu {
    .oneUl {
      margin-top: 40px;

      .oneLi {
        width: 160px;
        font-size: 18px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #333333;
        line-height: 24px;
        //position: relative;
        .zhang {
          margin-right: 10px;
        }

        .zhangContent {
        }

        .twoUl {
          margin-left: 32px;
          margin-top: 30px;
          margin-bottom: 50px;
          //position: absolute;
          //right: 0;
          li {
            width: 197px;
            font-size: 16px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #333333;
            line-height: 36px;
          }

          .jie {
            margin-right: 10px;
          }

          .jieContent {
          }
        }
      }
    }
  }
}
</style>
